module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cr mtop1"
  }, [_vm._v("© 2023 by Christopher Berry-Dee")]), _vm._v(" "), _c('p', {
    staticClass: "cr mtop"
  }, [_vm._v("All rights reserved, including the right to reproduce this book "), _c('br'), _vm._v("or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "cr mtop1"
  }, [_vm._v("First published in Great Britain by John Blake Publishing, an imprint of Bonnier Books")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cr mtop1"
  }, [_vm._v("Diversion Books")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("A division of Diversion Publishing Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_c('a', {
    attrs: {
      "href": "http://www.diversionbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cr mtop1"
  }, [_vm._v("First Diversion Books Edition: August 2023")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("Paperback ISBN: 9781635768602")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("eBook ISBN: 9781635768541")]), _vm._v(" "), _c('p', {
    staticClass: "cr mtop1"
  }, [_vm._v("Printed in the United States of America ")]), _vm._v(" "), _c('p', {
    staticClass: "cr"
  }, [_vm._v("15 16 17 18 19 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24553300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f004.vue
// module id = 66
// module chunks = 0